module.exports = "/_next/static/images/4aa2c04f8f4586fd6ae02bc28542dd8b-app-screenshots-md@2x.jpg.webp";